import EncryptRsa from "encrypt-rsa";

document.addEventListener("DOMContentLoaded", function() {
  var form = document.querySelector('form[action*="sign_in"]');
  if (!form) return;

  form.addEventListener("submit", function(e) {
    var passwordInput = form.querySelector('input[type="password"]');
    if (!passwordInput) return;

    var publicKeyMeta = document.querySelector('meta[name="rsa-public-key"]');
    if (!publicKeyMeta) return;
    var publicKey = publicKeyMeta.getAttribute("content");
    if (!publicKey) return;

    // Use encrypt-rsa to encrypt the password with OAEP padding
    const encryptRsa = new EncryptRsa();
    const encrypted = encryptRsa.encryptStringWithRsaPublicKey({
      text: passwordInput.value,
      publicKey: publicKey,
    });
    if (encrypted) {
      passwordInput.value = encrypted;
    }
  });
});